// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"48":"279f475526ab3059bd02","236":"f232023a2c0f4f9084fe"}[chunkId] + ".css";
};